import brcClientConstants from './brcClientConstants';

const {
  REQUIRE_FIELD_MSG,
  ENTERPRISE_SOLUTIONS_MERCATOR_STUDY
 } = brcClientConstants;

const getDefaultEloquaData = (checkSlug, country, digitiveTrive, enterpriseArticle) => {
  const eloquaData = {
    firstName: 'First Name*',
    lastName: 'Last Name*',
    email: 'Business Email*',
    companyName: 'Company Name*',
    mothlySales: 'Monthly Online Sales Volume',
    selectOne: 'Select One*',
    companyWebsite: 'Company Website*',
    countryCode: 'Country Code*',
    busPhone: 'Business Phone*',
    jobTitle: 'Job Title*',
    firstNameRequired: REQUIRE_FIELD_MSG,
    lastNameRequired: REQUIRE_FIELD_MSG,
    emailRequired: REQUIRE_FIELD_MSG,
    companyNameRequired: REQUIRE_FIELD_MSG,
    salesvolumeRequired: REQUIRE_FIELD_MSG,
    companyWebsiteRequired: REQUIRE_FIELD_MSG,
    coutryCodeRequired: REQUIRE_FIELD_MSG,
    phoneRequired: REQUIRE_FIELD_MSG,
    jobTitleRequired: 'Job title is required',
    dropShipperRequired: REQUIRE_FIELD_MSG,
    firstNameError: 'Invalid First Name',
    lastNameError: 'Invalid Last Name',
    emailError: 'Invalid Email',
    companyError: 'Invalid Company Name',
    companyWebsiteError: 'Enter valid website address',
    coutryCodeError: 'Enter valid country code',
    phoneError: 'Enter valid phone number',
    selectCheckbox: 'Please select checkbox',
    showLegalCheckbox: false,
  };
  if (checkSlug) {
    eloquaData.eloquaFormName = `APAC-${country.toUpperCase()}-2020-COE-Lead-Nurture-BC-BRC`;
    if(country === 'in') {
      eloquaData.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-05-18/tm4';
    }
  } else if(digitiveTrive) {
    eloquaData.eloquaFormName = `APAC-${country.toUpperCase()}-COE-Lead-Nurture-DT-BRC`;
    eloquaData.startSellingHeader = 'Start selling with PayPal';
    eloquaData.startSellingBody = 'A smart online growth plan can build business resiliency and drive sales. PayPal can help, by offering a secure, seamless payment experience for you and your customers, anywhere in the world. With more than 360 million active users, PayPal has the reach and expertise to help you make the most of your online store.';
    if(country === 'hk') {
      eloquaData.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-05-18/tlz';
    }
    if(country === 'sg') {
      eloquaData.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-05-19/vrj';
    }
  } else if(enterpriseArticle) {
    eloquaData.emailDomainError = 'Please enter a valid Business email ID';
    eloquaData.eloquaFormName = `APAC-${country.toUpperCase()}-COE-Lead-Nurture-Enterprise-BRC`;
    if(country === 'sg') {
      eloquaData.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-07-12/qh7y';
    }
    if(country === 'hk') {
      eloquaData.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-07-12/qhdh';
    }
    if(country === 'in') {
      eloquaData.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-07-13/qlzh';
    }
  } else {
    eloquaData.eloquaFormName = `APAC-${country.toUpperCase()}-2020-COE-Lead-Nurture-BRC`;
    if(country === 'sg') {
      eloquaData.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-05-18/tnq';
    }
    if(country === 'hk') {
      eloquaData.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-05-18/tlx';
    }
    if(country === 'in') {
      eloquaData.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-05-18/tm4';
    }
    if(country === 'vn') {
      eloquaData.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-06-03/5bv4';
    }
  }
  if(country === 'il' || country === 'ae' || enterpriseArticle) {
    eloquaData.showLegalCheckbox = true;
  }
  if(enterpriseArticle) {
    eloquaData.showBusinessNeeds = true;
    eloquaData.showBusinessNeedsLabel ='Tell us your business needs';
    if(country === 'in') {
      eloquaData.mothlySales = 'Annual Sales Volume';
    }
  }
  return eloquaData;

};

const getEloquaDataPL= (checkSlug, digitiveTrive, enterpriseArticle) => {
  const eloquaDataPL = {
    firstName: 'Imię*',
    lastName: 'Nazwisko*',
    email: 'Służbowy adres e-mail*',
    companyName: 'Nazwa firmy*',
    mothlySales: 'Wielkość miesięcznej sprzedaży online',
    selectOne: 'Wybierz jedną opcję*',
    companyWebsite: 'Adres WWW firmy*',
    countryCode: 'Kod kraju*',
    busPhone: 'Telefon służbowy*',
    jobTitle: 'Stanowisko*',
    firstNameRequired: 'Imię jest wymagane',
    lastNameRequired: 'Nazwisko jest wymagane',
    emailRequired: 'Służbowy adres e-mail jest wymagany',
    companyNameRequired: 'Nazwa firmy jest wymagana',
    salesvolumeRequired: 'Wielkość miesięcznej sprzedaży online jest wymagana',
    companyWebsiteRequired: 'Adres WWW firmy jest wymagany',
    coutryCodeRequired: 'Kod kraju jest wymagany',
    phoneRequired: 'Telefon służbowy jest wymagany',
    jobTitleRequired: 'Nazwa stanowiska jest wymagana',
    dropShipperRequired: '',
    firstNameError: 'Podaj poprawne imię',
    lastNameError: 'Podaj poprawne nazwisko',
    emailError: 'Podaj poprawny służbowy adres e-mail',
    companyError: 'Podaj poprawną nazwę firmy',
    companyWebsiteError: 'Podaj poprawny adres WWW firmy',
    coutryCodeError: 'Podaj poprawny kod kraju',
    phoneError: 'Podaj poprawny telefon służbowy',
    //textBeforeLink:'Useo',
    //linkText:'mapainterativo',
    //textAfterLink:,
    showLegalCheckbox: false,
  };
  if (checkSlug) {
    eloquaDataPL.eloquaFormName = 'ICE-PL-2020-COE-Lead-Nurture-BC-BRC';
  } else if(digitiveTrive) {
    eloquaDataPL.eloquaFormName = 'ICE-PL-COE-Lead-Nurture-DT-BRC';
  } else if(enterpriseArticle) {
    eloquaDataPL.eloquaFormName = 'ICE-PL-COE-Lead-Nurture-Enterprise-BRC';
    eloquaDataPL.showLegalCheckbox = true;
    eloquaDataPL.showBusinessNeeds = true;
    eloquaDataPL.showBusinessNeedsLabel = 'Jakie są Twoje potrzeby biznesowe?';
    eloquaDataPL.selectCheckbox = 'Zaznacz pole wyboru';
    eloquaDataPL.emailDomainError = 'Podaj poprawny adres e-mail w domenie firmowej';
  } else {
    eloquaDataPL.eloquaFormName = 'ICE-PL-2020-COE-Lead-Nurture-BRC';
  }
  return eloquaDataPL;
};

const getEloquaDataCZ = (checkSlug, digitiveTrive, enterpriseArticle) => {
  const eloquaDataCZ = {
    firstName: 'Křestní jméno*',
    lastName: 'Příjmení*',
    email: 'Firemní e-mail*',
    companyName: 'Název společnosti*',
    mothlySales: 'Objem měsíčních online tržeb',
    selectOne: 'Zvolte jednu možnost*',
    companyWebsite: 'Webová stránka společnosti*',
    countryCode: 'Telefonní předvolba země*',
    busPhone: 'Firemní telefon*',
    jobTitle: 'Pracovní pozice*',
    firstNameRequired: 'Křestní jméno je povinná položka',
    lastNameRequired: 'Příjmení je povinná položka',
    emailRequired: 'Firemní e-mail je povinná položka',
    companyNameRequired: 'Název společnosti je povinná položka',
    salesvolumeRequired: 'Objem měsíčních online tržeb je povinná položka',
    companyWebsiteRequired: 'Název společnosti je povinná položka',
    coutryCodeRequired: 'Telefonní předvolba země je povinná položka',
    phoneRequired: 'Firemní telefon je povinná položka',
    jobTitleRequired: 'Pracovní pozice je povinná položka',
    dropShipperRequired: '',
    firstNameError: 'Zadejte platné křestní jméno',
    lastNameError: 'Zadejte platné příjmení',
    emailError: 'Zadejte platný firemní e-mail',
    companyError: 'Zadejte platný název společnosti',
    companyWebsiteError: 'Zadejte platnou webovou stránku společnosti',
    coutryCodeError: 'Zadejte platnou telefonní předvolbu země',
    phoneError: 'Zadejte platný firemní telefon',
    //textBeforeLink:'Useo',
    //linkText:'mapainterativo',
    //textAfterLink:,
    showLegalCheckbox: false,
  };
  if (checkSlug) {
    eloquaDataCZ.eloquaFormName = 'ICE-CZ-2020-COE-Lead-Nurture-BC-BRC';
  } else if(digitiveTrive) {
    eloquaDataCZ.eloquaFormName = 'ICE-CZ-COE-Lead-Nurture-DT-BRC';
  } else if(enterpriseArticle) {
    eloquaDataCZ.eloquaFormName = 'ICE-CZ-COE-Lead-Nurture-Enterprise-BRC';
    eloquaDataCZ.showLegalCheckbox = true;
    eloquaDataCZ.showBusinessNeeds = true;
    eloquaDataCZ.showBusinessNeedsLabel = 'Řekněte nám, co vaše firma potřebuje';
    eloquaDataCZ.selectCheckbox = 'Zvolte zaškrtávací pole';
    eloquaDataCZ.emailDomainError = 'Zadejte platný e-mail na vlastní doméně';
  } else {
    eloquaDataCZ.eloquaFormName = 'ICE-CZ-2020-COE-Lead-Nurture-BRC';
  }
  return eloquaDataCZ;
};

const getEloquaDataHU = (checkSlug, digitiveTrive, enterpriseArticle) => {
  const eloquaDataHU = {
    firstName: 'Keresztnév*',
    lastName: 'Családnév*',
    email: 'Céges e-mail*',
    companyName: 'Cégnév*',
    mothlySales: 'Havi online eladási volumen',
    selectOne: 'Válasszon!*', //need change
    companyWebsite: 'Céges weboldal*',
    countryCode: 'Országkód*',
    busPhone: 'Céges telefonszám*',
    jobTitle: 'Pozíció*',
    firstNameRequired: 'A keresztnév megadása kötelező.',
    lastNameRequired: 'A családnév megadása kötelező.',
    emailRequired: 'A céges e-mail-cím megadása kötelező.',
    companyNameRequired: 'A cégnév megadása kötelező.',
    salesvolumeRequired: 'A havi online eladási volumen megadása kötelező.',
    companyWebsiteRequired: 'A cég webcímének megadása kötelező.',
    coutryCodeRequired: 'Az országkód megadása kötelező.',
    phoneRequired: 'A céges telefonszám megadása kötelező.',
    jobTitleRequired: 'A pozíció megadása kötelező.',
    dropShipperRequired: '',
    firstNameError: 'Valós keresztnevet adjon meg.',
    lastNameError: 'Valós családnevet adjon meg.',
    emailError: 'Valós céges e-mail-címet adjon meg.',
    companyError: 'Valós cégnevet adjon meg.',
    companyWebsiteError: 'Valós céges webcímet adjon meg.',
    coutryCodeError: 'Valós országkódot adjon meg.',
    phoneError: 'Valós céges telefonszámot adjon meg.',
    //textBeforeLink:'Useo',
    //linkText:'mapainterativo',
    //textAfterLink:,
    showLegalCheckbox: false,
  };
  if (checkSlug) {
    eloquaDataHU.eloquaFormName = 'ICE-HU-2020-COE-Lead-Nurture-BC-BRC';
  } else if(digitiveTrive) {
    eloquaDataHU.eloquaFormName = 'ICE-HU-COE-Lead-Nurture-DT-BRC';
  } else if(enterpriseArticle) {
    eloquaDataHU.eloquaFormName = 'ICE-HU-COE-Lead-Nurture-Enterprise-BRC';
    eloquaDataHU.showLegalCheckbox = true;
    eloquaDataHU.showBusinessNeeds = true;
    eloquaDataHU.showBusinessNeedsLabel = 'Írja le, mire van szüksége vállalkozásának!';
    eloquaDataHU.selectCheckbox = 'Jelölje be a négyzetet!';
    eloquaDataHU.emailDomainError = 'Vállalkozása valós e-mail-címét adja meg!';
  } else {
    eloquaDataHU.eloquaFormName = 'ICE-HU-2020-COE-Lead-Nurture-BRC';
  }
  return eloquaDataHU;

};

const getEloquaDataGR = (checkSlug, digitiveTrive, enterpriseArticle) => {
  const eloquaDataGR = {
    firstName: 'Όνομα*',
    lastName: 'Επίθετο*',
    email: 'Email επιχείρησης*',
    companyName: 'Επωνυμία επιχείρησης*',
    mothlySales: 'Μηνιαίος όγκος πωλήσεων μέσω internet',
    selectOne: 'Επιλέξτε Ένα*',
    companyWebsite: 'Ιστότοπος εταιρείας*',
    countryCode: 'Κωδικός χώρας*',
    busPhone: 'Τηλέφωνο επιχείρησης*',
    jobTitle: 'Τίτλος*',
    firstNameRequired: 'Απαιτείται όνομα',
    lastNameRequired: 'Απαιτείται επίθετο',
    emailRequired: 'Απαιτείται email επιχείρησης',
    companyNameRequired: 'Απαιτείται επωνυμία επιχείρησης',
    salesvolumeRequired: 'Απαιτείται ο μηνιαίος όγκος πωλήσεων μέσω internet',
    companyWebsiteRequired: 'Απαιτείται ο ιστότοπος της επιχείρησης',
    coutryCodeRequired: 'Απαιτείται κωδικός χώρας',
    phoneRequired: 'Απαιτείται τηλέφωνο επιχείρησης',
    jobTitleRequired: 'Απαιτείται τίτλος',
    dropShipperRequired: '',
    firstNameError: 'Εισαγάγετε έγκυρο όνομα',
    lastNameError: 'Εισαγάγετε έγκυρο επίθετο',
    emailError: 'Εισαγάγατε έγκυρο email επιχείρησης',
    companyError: 'Εισαγάγετε έγκυρη επωνυμία επιχείρησης',
    companyWebsiteError: 'Εισαγάγετε έγκυρο ιστότοπο επιχείρησης',
    coutryCodeError: 'Εισαγάγετε έγκυρο κωδικό χώρας',
    phoneError: 'Εισαγάγετε έγκυρο τηλέφωνο επιχείρησης',
    //textBeforeLink:'Useo',
    //linkText:'mapainterativo',
    //textAfterLink:,
    showLegalCheckbox: false,
  };
  if (checkSlug) {
    eloquaDataGR.eloquaFormName = 'ICE-GR-2020-COE-Lead-Nurture-BC-BRC';
  } else if(digitiveTrive) {
    eloquaDataGR.eloquaFormName = 'ICE-GR-COE-Lead-Nurture-DT-BRC';
  } else if(enterpriseArticle) {
    eloquaDataGR.eloquaFormName = 'ICE-GR-COE-Lead-Nurture-Enterprise-BRC';
    eloquaDataGR.showLegalCheckbox = true;
    eloquaDataGR.showBusinessNeeds = true;
    eloquaDataGR.showBusinessNeedsLabel = 'Πείτε μας τις ανάγκες της επιχείρησής σας';
    eloquaDataGR.selectCheckbox = 'Παρακαλούμε επιλέξτε το κουτάκι';
    eloquaDataGR.emailDomainError = 'Παρακαλούμε εισάγετε ένα έγκυρο εταιρικό email';
  } else {
    eloquaDataGR.eloquaFormName = 'ICE-GR-2020-COE-Lead-Nurture-BRC';
  }
  return eloquaDataGR;
};

const getEloquaDataC2 = (checkSlug, digitiveTrive) => {
  const eloquaDatac2 = {
    // eloquaFormName: eloquaFormName,
    firstName: '名*',
    lastName: '姓*',
    email: '企业邮箱*',
    companyName: '公司名称*',
    mothlySales: '月线上销售量',
    selectOne: '选择一项*',
    companyWebsite: '公司网站*',
    countryCode: '国家代码*',
    busPhone: '企业电话*',
    jobTitle: '职位名称*',
    firstNameRequired: '名字必填',
    lastNameRequired: '姓氏必填',
    emailRequired: '企业邮箱必填',
    companyNameRequired: '公司名称必填',
    salesvolumeRequired: '月线上销售量必填',
    companyWebsiteRequired: '公司网站必填',
    coutryCodeRequired: '国家代码必填',
    phoneRequired: '企业电话必填',
    jobTitleRequired: 'job title required',
    dropShipperRequired: '',
    firstNameError: '输入有效名字',
    lastNameError: '输入有效姓氏',
    emailError: '输入有效企业邮箱',
    companyError: '输入有效公司名称',
    companyWebsiteError: '输入有效公司网站',
    coutryCodeError: '输入有效国家代码',
    phoneError: '输入有效企业电话',
    // textBeforeLink: '使用 ',
    // linkText: 'PayPal 互动地图',
    // textAfterLink: '探索报告中包含的国家和地区。',
    showLegalCheckbox: false,
  };
  if (checkSlug) {
    eloquaDatac2.eloquaFormName = 'APAC-CN-2020-COE-Lead-Nurture-BC-BRC';
  } else if(digitiveTrive) {
    eloquaDatac2.eloquaFormName = 'APAC-C2-COE-Lead-Nurture-DT-BRC';
  } else {
    eloquaDatac2.eloquaFormName = 'APAC-CN-2020-COE-Lead-Nurture-BRC';
  }
  return eloquaDatac2;
};

const getEloquaDataJP = (checkSlug, digitiveTrive, enterpriseArticle, firstEnterpriseArticle, secondEnterpriseArticle, slugId) => {
// var eloquaFormName;

  const eloquaDataJP = {
  // eloquaFormName: eloquaFormName,
    firstName: '名*',
    lastName: '姓*',
    email: 'メールアドレス*',
    companyName: '貴社名*',
    mothlySales: '月間オンライン売上高:',
    selectOne: 'お選びください*',
    companyWebsite: '会社のウエブサイトURL*',
    countryCode: '国番号*',
    busPhone: '電話番号*',
    jobTitle: '役職名*',
    firstNameRequired: '名は必須です',
    lastNameRequired: '姓は必須です',
    emailRequired: 'メールアドレスは必須です',
    companyNameRequired: '貴社名は必須です',
    salesvolumeRequired: '月間オンライン売上高は必須です',
    companyWebsiteRequired: '会社のウエブサイトURLは必須です',
    coutryCodeRequired: '国番号は必須です',
    phoneRequired: '電話番号は必須です',
    jobTitleRequired: '役職名は必須です',
    dropShipperRequired: '',
    firstNameError: '名を正しく入力してください',
    lastNameError: '姓を正しく入力してください',
    emailError: 'メールアドレスを正しく入力してください',
    companyError: '貴社名を正しく入力してください',
    companyWebsiteError: '貴社のウエブサイトURLを正しく入力してください',
    coutryCodeError: '国番号を正しく入力してください',
    phoneError: '電話番号を正しく入力してください',
    showLegalCheckbox: false,
    orderLastBeforeFirst: true,
  };
  if (slugId === 'SFCC-2021') {
    eloquaDataJP.eloquaFormName = 'APAC-JP-FRH-21-CHP-lead-gen-page-SFCC';
    eloquaDataJP.mothlySales = '貴社の年間売上高(予測)*';
    eloquaDataJP.showLegalCheckbox = true;
    eloquaDataJP.selectCheckbox = 'ご同意いただける場合はチェックを入れてください';
    eloquaDataJP.emailDomainError = '有効なビジネス用メールアドレスを入力してください';
    eloquaDataJP.shoppingCart = '貴社ウェブサイトでご利用のショッピングカートシステム*';
    eloquaDataJP.shoppingCartRequired = '必ずお選びください';
    eloquaDataJP.shoppingCartOption = ['Salesforce Commerce Cloud', 'Magento', 'Shopify', 'その他'];
    eloquaDataJP.paymentServiceProvider = '貴社ウェブサイトでご利用の決済代行会社';
    eloquaDataJP.showQuestionBox = '(任意)ご質問などございましたら、ご記入ください';
    eloquaDataJP.showBusinessAccount = 'ペイパルビジネスアカウントをお持ちですか？*';
    eloquaDataJP.businessAccountRequired = '必ずお選びください';
    eloquaDataJP.businessAccountYes = 'はい';
    eloquaDataJP.businessAccountNo = 'いいえ';
    eloquaDataJP.pardotActionUrl ='https://pypd.paypal-mktg.com/l/925803/2021-07-29/28zw7';
  } else if (checkSlug) {
    eloquaDataJP.eloquaFormName = 'APAC-JP-2020-COE-Lead-Nurture-BC-BRC';
  } else if(digitiveTrive) {
    eloquaDataJP.eloquaFormName = 'APAC-JP-COE-Lead-Nurture-DT-BRC';
    eloquaDataJP.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-05-18/tmn';
    eloquaDataJP.companyWebsite= '貴社のウェブサイトURL*';
    eloquaDataJP.startSellingHeader = 'ペイパル決済を導入しましょう';
    eloquaDataJP.startSellingBody = '効率的なオンラインストア運営プランを立てることで、景気の変化に揺るがないビジネスの構築と売り上げアップが可能になります。ペイパルは、世界中どこからでも利用できる安全でスムーズな決済システムを提供します。ペイパルは、世界中で3億5000万人以上の消費者そして2800万を超える店舗に利用されています。その専門知識とマーケットへの普及率により、皆さんのオンラインビジネスを成長にサポートします。';
  } else if(enterpriseArticle) {
    eloquaDataJP.mothlySales = '貴社の年間売上高(予測)*';
    eloquaDataJP.showLegalCheckbox = true;
    eloquaDataJP.showBusinessNeeds = true;
    eloquaDataJP.showBusinessNeedsLabel = '(任意)ご質問等ございましたら、ご記入ください';
    eloquaDataJP.selectCheckbox = 'ご同意いただける場合はチェックを入れてください';
    eloquaDataJP.emailDomainError = '有効なビジネス用メールアドレスを入力してください';
    if(firstEnterpriseArticle) {
      eloquaDataJP.eloquaFormName = 'APAC-JP-COE-Lead-Nurture-Enterprise-BRC';
    }
    if(secondEnterpriseArticle) {
      eloquaDataJP.eloquaFormName = 'APAC-JP-FRM-21-ENT-UCC';
      eloquaDataJP.showBusinessNeeds = false;
      eloquaDataJP.pardotActionUrl ='https://pypd.paypal-mktg.com/l/925803/2021-07-27/28m1f';
    }
  } else {
    eloquaDataJP.eloquaFormName = 'APAC-JP-2020-COE-Lead-Nurture-BRC';
  }
  return eloquaDataJP;
};

const getEloquaDataMX = (checkSlug, digitiveTrive, enterpriseArticle, firstEnterpriseArticle, secondEnterpriseArticle, slugId) => {
  // var eloquaFormName;

  const eloquaDataMX = {
    // eloquaFormName: eloquaFormName,
    firstName: 'Nombre completo*',
    lastName: 'Apellido completo*',
    email: 'E-mail del trabajo*',
    companyName: 'Nombre de empresa*',
    mothlySales: 'Ventas mensuales estimadas por internet (MXN):',
    selectOne: 'Seleccione uno*',
    companyWebsite: 'Sitio web de la empresa*',
    countryCode: 'Código de país*',
    busPhone: 'Teléfono de la empresa*',
    jobTitle: 'Puesto De Trabajo*',
    firstNameRequired: 'Se requiere el primer nombre',
    lastNameRequired: 'Se requiere el apellido',
    emailRequired: 'Se requiere el correo electrónico del negocio',
    companyNameRequired: 'Se requiere el nombre de la empresa',
    salesvolumeRequired:
      'Se requiere el volumen mensual de ventas en línea',
    companyWebsiteRequired: 'Se requiere el sitio web de la empresa',
    coutryCodeRequired: 'Se requiere el código del país',
    phoneRequired: 'Se requiere el teléfono del negocio',
    jobTitleRequired: 'Se requiere un puesto de trabajo',
    dropShipperRequired: '',
    firstNameError: 'Ingrese un primer nombre válido',
    lastNameError: 'Ingrese un apellido válido',
    emailError: 'Ingrese un correo electrónico de negocio válido',
    companyError: 'Ingrese el nombre de empresa válido',
    companyWebsiteError: 'Ingrese el sitio web de empresa válido',
    coutryCodeError: 'Ingrese el código de país válido',
    phoneError: 'Ingrese el teléfono de negocio válido',
    showLegalCheckbox: false,
  };
  if (checkSlug) {
    eloquaDataMX.eloquaFormName = 'LATAM-MX-2020-COE-Lead-Nurture-BC-BRC';
  } else if(digitiveTrive) {
    eloquaDataMX.eloquaFormName = 'LATAM-MX-COE-Lead-Nurture-DT-BRC';
    eloquaDataMX.startSellingHeader = 'Empieza a vender con PayPal';
    eloquaDataMX.startSellingBody = 'Un plan de crecimiento en línea inteligente ayuda a impulsar las ventas y desarrollar resiliencia en tu negocio. PayPal te apoya al ofrecer una experiencia de pago segura y fluida para ti y tus clientes, en cualquier parte del mundo. Con más de 360 millones de usuarios activos y más de 26 millones de negocios en todo el mundo, PayPal tiene el alcance y la experiencia para ayudarte a aprovechar al máximo tu tienda en línea.';
    eloquaDataMX.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-05-19/wq8';
  } else if(enterpriseArticle) {
    eloquaDataMX.firstName = 'Nombre*';
    eloquaDataMX.lastName = 'Apellido*';
    eloquaDataMX.email = 'Correo electrónico de negocios*';
    eloquaDataMX.companyName = 'Nombre de la empresa*';
    eloquaDataMX.mothlySales = 'Volumen de ventas mensuales por internet*';
    eloquaDataMX.busPhone = 'Teléfono*';
    eloquaDataMX.showLegalCheckbox = true;
    eloquaDataMX.showBusinessNeeds = true;
    eloquaDataMX.showBusinessNeedsLabel = 'Cuéntanos más sobre tus necesidades';
    eloquaDataMX.provideInstalmentsTitle = '¿Actualmente ofreces pagos a meses sin intereses a tus clientes?*';
    eloquaDataMX.provideInstalmentsYes = 'Si';
    eloquaDataMX.provideInstalmentsNo = 'No';
    eloquaDataMX.selectRadioCheckbox = 'Este campo es requerido';
    eloquaDataMX.selectCheckbox = 'Por favor selecciona el checkbox';
    eloquaDataMX.emailDomainError = 'Ingrese una dirección de correo electrónico comercial válida';
    if(firstEnterpriseArticle) {
      if(slugId === ENTERPRISE_SOLUTIONS_MERCATOR_STUDY) {
        eloquaDataMX.eloquaFormName = 'LATAM-MX-COE-Lead-Nurture-BRC';
        eloquaDataMX.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-08-17/2cw23';
      } else {
        eloquaDataMX.eloquaFormName = 'LATAM-MX-COE-Lead-Nurture-Enterprise-BRC';
        eloquaDataMX.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-07-12/qhh1';
      }
    }
    if(secondEnterpriseArticle) {
      eloquaDataMX.eloquaFormName = 'LATAM-MX-FRM-21-ENT-NavigatingPayments';
      eloquaDataMX.showBusinessNeeds = false;
      eloquaDataMX.pardotActionUrl ='https://pypd.paypal-mktg.com/l/925803/2021-07-27/28n6f';
    }
  } else {
    eloquaDataMX.eloquaFormName = 'LATAM-MX-2020-COE-Lead-Nurture-BRC';
    eloquaDataMX.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-05-19/wq4';
  }
  return eloquaDataMX;
};

const getEloquaDataBR = (checkSlug, digitiveTrive, enterpriseArticle, slugId) => {
  const eloquaDataBR =   {
    // eloquaFormName: eloquaFormName,
    firstName: 'Nome*',
    lastName: 'Sobrenome*',
    email: 'E-mail profissional*',
    companyName: 'Nome Da Empresa*',
    mothlySales: 'Volume Mensal De Vendas On-line(R$)',
    selectOne: 'Selecione Um*',
    companyWebsite: 'Site Da Empresa*',
    countryCode: 'Código Do País*',
    busPhone: 'Número de telefone*',
    jobTitle: 'Cargo*',
    firstNameRequired: 'É obrigatório especificar um nome',
    lastNameRequired: 'É obrigatório especificar um sobrenome',
    emailRequired: 'É obrigatório especificar um e-mail profissional',
    companyNameRequired: 'É obrigatório especificar um nome de empresa',
    salesvolumeRequired:
      'É obrigatório especificar o volume de vendas mensal on-line',
    companyWebsiteRequired: 'É obrigatório especificar um site corporativo',
    coutryCodeRequired: 'É obrigatório especificar um código de país',
    phoneRequired: 'É obrigatório especificar um telefone comercial',
    jobTitleRequired: 'É obrigatório especificar uma posição',
    dropShipperRequired: '',
    firstNameError: 'Insira um nome válido',
    lastNameError: 'Insira um sobrenome válido',
    emailError: 'Insira um e-mail profissional válido',
    companyError: 'Insira um nome de empresa válido',
    companyWebsiteError: 'Insira um site corporativo válido',
    coutryCodeError: 'Insira um código de país válido',
    phoneError: 'Insira um telefone comercial válido',
    showLegalCheckbox: false,
  };
  if (checkSlug) {
    eloquaDataBR.eloquaFormName = 'LATAM-BR-2020-COE-Lead-Nurture-BC-BRC';
  } else if(digitiveTrive) {
    eloquaDataBR.eloquaFormName = 'LATAM-BR-COE-Lead-Nurture-DT-BRC';
    eloquaDataBR.startSellingHeader = 'Comece a vender com PayPal';
    eloquaDataBR.startSellingBody = 'Um plano de crescimento on-line inteligente pode aumentar a resiliência – e as vendas – da sua empresa. Com uma experiência de pagamento segura e sem complicação para você e seus clientes, o PayPal pode ajudar sua empresa a conquistar o mundo. Com mais de 360 milhões de usuários ativos e mais de 26 milhões de vendedores mundo afora, o PayPal tem o alcance e a experiência necessários para ajudar você a aproveitar tudo que sua loja virtual tem a oferecer.';
    eloquaDataBR.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-05-19/wpx';
  } else if(enterpriseArticle) {
    if(slugId === ENTERPRISE_SOLUTIONS_MERCATOR_STUDY) {
      eloquaDataBR.eloquaFormName = 'LATAM-BR-COE-Lead-Nurture-BRC';
      eloquaDataBR.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-08-17/2cw37';
    } else {
      eloquaDataBR.eloquaFormName = 'LATAM-BR-COE-Lead-Nurture-Enterprise-BRC';
      eloquaDataBR.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-07-12/qhgp';
    }
    eloquaDataBR.showLegalCheckbox = true;
    eloquaDataBR.showBusinessNeeds = true;
    eloquaDataBR.showBusinessNeedsLabel = 'Conte-nos mais sobre suas necessidades';
    eloquaDataBR.provideInstalmentsTitle = 'Atualmente oferece a opção de parcelamento sem juros para seus clientes?';
    eloquaDataBR.provideInstalmentsYes = 'Sim';
    eloquaDataBR.provideInstalmentsNo = 'Não';
    eloquaDataBR.selectRadioCheckbox = 'É obrigatório preencher este campo';
    eloquaDataBR.selectCheckbox = 'Marque a caixa de seleção';
    eloquaDataBR.emailDomainError = 'Insira um e-mail comercial válido';
  } else {
    eloquaDataBR.eloquaFormName = 'LATAM-BR-2020-COE-Lead-Nurture-BRC';
    eloquaDataBR.pardotActionUrl = 'https://pypd.paypal-mktg.com/l/925803/2021-05-19/wmn';
  }
};

const getGatewayContent = (country, slugId) => {
  const firstEnterpriseSlugs = [ENTERPRISE_SOLUTIONS_MERCATOR_STUDY,
    'guide-to-effective-online-payments',
    'enterprise-solutions-new-payments-processor',
  ];
  const secondEnterpriseSlugs = [
    'enterprise-ucc-june-2021',
    'enterprise-solutions-navigating-new-era-payments',
  ];
  const checkSlug =
    slugId === 'borderless-commerce' || slugId === 'borderless-commerce-1';
  const digitiveTrive = slugId === 'digitise-thrive';
  const firstEnterpriseArticle = firstEnterpriseSlugs.includes(slugId);
  const secondEnterpriseArticle = secondEnterpriseSlugs.includes(slugId);
  const enterpriseArticle = firstEnterpriseArticle || secondEnterpriseArticle;

  switch (country) {
    case 'br':
      return getEloquaDataBR(checkSlug, digitiveTrive, enterpriseArticle, slugId);
    case 'mx':
      return getEloquaDataMX(checkSlug, digitiveTrive, enterpriseArticle, firstEnterpriseArticle, secondEnterpriseArticle, slugId);
    case 'jp':
      return getEloquaDataJP(checkSlug, digitiveTrive, enterpriseArticle, firstEnterpriseArticle, secondEnterpriseArticle, slugId);
    case 'c2':
      return getEloquaDataC2(checkSlug, digitiveTrive);
    case 'gr':
      return getEloquaDataGR(checkSlug, digitiveTrive, enterpriseArticle);
    case 'hu':
      return getEloquaDataHU(checkSlug, digitiveTrive, enterpriseArticle);
    case 'cz':
      return getEloquaDataCZ(checkSlug, digitiveTrive, enterpriseArticle);
    case 'pl':
      return getEloquaDataPL(checkSlug, digitiveTrive, enterpriseArticle);
    default: {
      return getDefaultEloquaData(checkSlug, country, digitiveTrive, enterpriseArticle);
    }
  }
};

export default getGatewayContent;
